import React from 'react'
import './style.scss'
import {connect} from 'react-redux'
class Nav extends React.Component{
    constructor(props){
        super(props);
        this.state = {

        }
    }
    render(){
        const {content, isLoading} = this.props.Content
       if(isLoading){
        return(
            <div className=""></div>
        )
       }else{
        return (
            <div className="Nav">
                <div class="nav-wrap">
                    <div class="nav">
                    {content.navbar.items.map((item) => (
                            <a href="#" onClick={() => this.props.tab(item.key)}>{item.text}</a>
                        ))}
                    </div>
                </div>
            </div>
        )
       }
    }
}
const mapStateToProps = (store) => ({
    Content: store.content
  })
export default connect(mapStateToProps)(Nav)